import React, { useEffect } from 'react'
import { VStack, Box } from '@chakra-ui/react'
import { CardNumberInput } from './CardNumberInput'
import { ExpiryDateInput } from './ExpiryDateInput'
import { CardHolderInput } from './CardHolderInput'
import { SecurityCodeInput } from './SecurityCodeInput'
import { useCardFormState } from '../hooks/useCardFormState'

/**
 * カードフォームコンポーネント
 * 各入力コンポーネントから値とバリデーション結果を受け取り、統合して親に通知
 */
export const CardForm = ({ onFormChange }) => {
  const { formData, isFormComplete, handlers } = useCardFormState()

  // 親コンポーネントにフォーム状態を通知
  useEffect(() => {
    if (onFormChange) {
      onFormChange({
        formData,
        isFormComplete,
      })
    }
  }, [formData, isFormComplete, onFormChange])

  return (
    <Box bg="white" borderRadius="8px" p="16px">
      <VStack gap={4} align="stretch">
        <CardNumberInput onChange={handlers.handleCardNumberChange} />
        <ExpiryDateInput onChange={handlers.handleExpiryChange} />
        <CardHolderInput onChange={handlers.handleCardHolderChange} />
        <SecurityCodeInput onChange={handlers.handleSecurityCodeChange} />
      </VStack>
    </Box>
  )
}
